import { ConnectButton } from '@rainbow-me/rainbowkit'
import React from 'react'
import Web3 from 'web3'
import {
	useAccount,
	useChainId,
  	usePrepareTransactionRequest,
  	useSendTransaction,
  	useWaitForTransactionReceipt,
} from 'wagmi'
import { parseEther } from 'viem'
import { config } from './config'

import x from './imgs/icon--twitter.png'
import closeImg from './imgs/close.png'

import dd from './imgs/h-icon.png'
import pend from './imgs/pending.gif'

import uwu from './imgs/uwu.png'
import xi from './imgs/x-icon.png'
import ce from './imgs/cute-edwin.png'
import bg from './imgs/bg.gif'
import mc from './imgs/mc.png'
import usdc from './imgs/usdc.png'
import husd from './imgs/husd.png'
import planet from './imgs/planet.png'
import {pools, poolImage} from './pools.js'
import sts from './imgs/sts.webp'
import ex from './imgs/ex.png'
import xex from './imgs/xex.png'
const EX_LIMIT = 154793


const USDC = "0x29219dd400f2Bf60E5a23d13Be72B486D4038894"

const ZEROS = new Array(22).fill(0)
const tokens = [ 
"0xe920d1DA9A4D59126dC35996Ea242d60EFca1304",
"0x9bCeA390ff97e0d3362bf726820776a4dF8AdD9a",
"0x068e9e009fDa970fA953E1f6a43D982cA991F4bA",
"0x893A5F9CA92Ca721089b6dAb44949dbd70CbC711",
"0x9990dE39Ca46151150E392Ca96EB349d0f549166",
"0xE569821A7b621Cc16C447C19297089b7205a6D30",
"0x9fDbC3f8Abc05Fa8f3Ad3C17D2F806c1230c4564",
"0x17Af1Df44444AB9091622e4Aa66dB5BB34E51aD5",
"0x50Bc6e1DfF8039A4b967c1BF507ba5eA13fa18B6",
"0xFFC05D77E021F12878644537398160A54E33B5e4",
"0xf2fC4c21F1B69fd4B633b4be532DEDEd6ab68715",
"0x3333111A391cC08fa51353E9195526A70b333333",
"0x873e509A21b106937472834201d653Ba62951c7E",
"0x38628cb4cc74cbDFB6dDD877B17c1F60fCAE7C2C",
"0x6fB9897896Fe5D05025Eb43306675727887D0B7c",
"0x486B6Fa0419b33a0c7A6e4698c231D7E2f2D5299",
"0xbeE65E9AF970ef637a84293D238db4528a53BB47",
"0xf1c9b8171Bf3902554e791010CCBCD6bacBA6eFd",
"0xE4A4353CD8F008f1a70f1a564535990479E8ceb7",
"0x4EEC869d847A6d13b0F6D1733C5DEC0d1E741B4f",
"0x7A08Bf5304094CA4C7b4132Ef62b5EDc4a3478B7",
"0x94B999e05D1361A802aD6690c1b1aE3426A4e1a6"
]
const tokenNames = [
      "DERP",
      "UPPIES",
      "WHALE",
      "Sonichu",
      "SPEED",
      "POOR",
      "GOGLZ",
      "THC",
      "sDOG",
      "CANDLE",
      "YE",
      "x33",
      "SHRIMP",
      "BOL",
      "HEDGY",
      "MOON",
      "SEX",
      "180042069",
      "PAL",
      "INDI",
      "ECO",
      "fSIX"
    ]


const getTransactionReceipt = (hash, callback= ()=>{}) => {
    console.log(hash)
    window.ethereum.request({
      method: "eth_getTransactionReceipt",
      params: [hash]
    }).then((res)=>{
      if (res == null) {
        getTransactionReceipt(hash, callback)
      }
      callback(res)
    }).catch((err)=>{
      console.log(err)
    })
  }

// const web3 = new Web3(new Web3.providers.HttpProvider('https://rpc.blaze.soniclabs.com'));
const web3 = new Web3(new Web3.providers.HttpProvider('https://rpc.soniclabs.com'));
export function Web3App (props) {
	const [cost, setCost] = React.useState(100)  
	const [pending, setIsPending] = React.useState(false)
	const [pendingText, setPendingText] = React.useState("Transaction is in process") 
	const { address, isConnected } = useAccount()
	const chainId  = useChainId()

	const [networkConfig, setNetworkConfig] = React.useState(config["mainnet"])
	const [hubbleBalance, setHubbleBalance] = React.useState(0)
	const [xhubbleBalance, setXHubbleBalance] = React.useState(0)
	const [vestInfo, setVestInfo] = React.useState({amt:0,start:0,end:0,id:0})
	const [vestCount, setVestCount]= React.useState(0)
	const [activeVest, setActiveVest] = React.useState(0)

	const [totalSubmissions, setTotalSubmissions] = React.useState(0)
	const [wlCount, setWlCount] = React.useState(0)

	const [activeStep, setActiveStep] = React.useState(0)

	const [theList, setTheList] = React.useState([])
	const [theNames, setTheNames] = React.useState([])
	const [theSymbols, setTheSymbols] = React.useState([])

	const [mcBalance, setMcBalance] = React.useState(0)

	const [userVotes, setUserVotes] = React.useState(ZEROS)
	const [totalVotesByPool, setTotalVotesByPool] = React.useState(ZEROS)
	const [totalVotes, setTotalVotes] = React.useState(0)
	const [navMobileToggle, setNavMobileToggle] = React.useState(false)

	const [mcCriticalRewards, setMcCriticalRewards] = React.useState(0)
	const [mcNCR_1, setMcNCR_1] = React.useState(0)
	const [mcNCR_2, setMcNCR_2] = React.useState(0)

	const [pool_totalTokens_0, set_pool_totalTokens_0] = React.useState(0)
    const [pool_totalTokens_1, set_pool_totalTokens_1] = React.useState(0)
    const [pool_totalTokens_2, set_pool_totalTokens_2] = React.useState(0)
    const [pool_totalTokens_3, set_pool_totalTokens_3] = React.useState(0)
const [pool_totalTokens_4, set_pool_totalTokens_4] = React.useState(0)
const [pool_totalTokens_5, set_pool_totalTokens_5] = React.useState(0)
const [pool_totalTokens_6, set_pool_totalTokens_6] = React.useState(0)
const [pool_totalTokens_7, set_pool_totalTokens_7] = React.useState(0)
const [pool_totalTokens_8, set_pool_totalTokens_8] = React.useState(0)
const [pool_totalTokens_9, set_pool_totalTokens_9] = React.useState(0)
const [pool_totalTokens_10, set_pool_totalTokens_10] = React.useState(0)
const [pool_totalTokens_11, set_pool_totalTokens_11] = React.useState(0)
const [pool_totalTokens_12, set_pool_totalTokens_12] = React.useState(0)
const [pool_totalTokens_13, set_pool_totalTokens_13] = React.useState(0)
const [pool_totalTokens_14, set_pool_totalTokens_14] = React.useState(0)
const [pool_totalTokens_15, set_pool_totalTokens_15] = React.useState(0)
const [pool_totalTokens_16, set_pool_totalTokens_16] = React.useState(0)
const [pool_totalTokens_17, set_pool_totalTokens_17] = React.useState(0)
const [pool_totalTokens_18, set_pool_totalTokens_18] = React.useState(0)
const [pool_totalTokens_19, set_pool_totalTokens_19] = React.useState(0)
const [pool_totalTokens_20, set_pool_totalTokens_20] = React.useState(0)
const [pool_totalTokens_21, set_pool_totalTokens_21] = React.useState(0)
const [pool_totalTokens_22, set_pool_totalTokens_22] = React.useState(0)
const [pool_totalTokens_23, set_pool_totalTokens_23] = React.useState(0)

const [pool_tokenPrice_0, set_pool_tokenPrice_0] = React.useState(0)
const [pool_tokenPrice_1, set_pool_tokenPrice_1] = React.useState(0)
const [pool_tokenPrice_2, set_pool_tokenPrice_2] = React.useState(0)
const [pool_tokenPrice_3, set_pool_tokenPrice_3] = React.useState(0)
const [pool_tokenPrice_4, set_pool_tokenPrice_4] = React.useState(0)
const [pool_tokenPrice_5, set_pool_tokenPrice_5] = React.useState(0)
const [pool_tokenPrice_6, set_pool_tokenPrice_6] = React.useState(0)
const [pool_tokenPrice_7, set_pool_tokenPrice_7] = React.useState(0)
const [pool_tokenPrice_8, set_pool_tokenPrice_8] = React.useState(0)
const [pool_tokenPrice_9, set_pool_tokenPrice_9] = React.useState(0)
const [pool_tokenPrice_10, set_pool_tokenPrice_10] = React.useState(0)
const [pool_tokenPrice_11, set_pool_tokenPrice_11] = React.useState(0)
const [pool_tokenPrice_12, set_pool_tokenPrice_12] = React.useState(0)
const [pool_tokenPrice_13, set_pool_tokenPrice_13] = React.useState(0)
const [pool_tokenPrice_14, set_pool_tokenPrice_14] = React.useState(0)
const [pool_tokenPrice_15, set_pool_tokenPrice_15] = React.useState(0)
const [pool_tokenPrice_16, set_pool_tokenPrice_16] = React.useState(0)
const [pool_tokenPrice_17, set_pool_tokenPrice_17] = React.useState(0)
const [pool_tokenPrice_18, set_pool_tokenPrice_18] = React.useState(0)
const [pool_tokenPrice_19, set_pool_tokenPrice_19] = React.useState(0)
const [pool_tokenPrice_20, set_pool_tokenPrice_20] = React.useState(0)
const [pool_tokenPrice_21, set_pool_tokenPrice_21] = React.useState(0)
const [pool_tokenPrice_22, set_pool_tokenPrice_22] = React.useState(0)
const [pool_tokenPrice_23, set_pool_tokenPrice_23] = React.useState(0)
const [userInfo_0, set_userInfo_0] = React.useState(0)
const [userInfo_1, set_userInfo_1] = React.useState(0)
const [userInfo_2, set_userInfo_2] = React.useState(0)
const [userInfo_3, set_userInfo_3] = React.useState(0)
const [userInfo_4, set_userInfo_4] = React.useState(0)
const [userInfo_5, set_userInfo_5] = React.useState(0)
const [userInfo_6, set_userInfo_6] = React.useState(0)
const [userInfo_7, set_userInfo_7] = React.useState(0)
const [userInfo_8, set_userInfo_8] = React.useState(0)
const [userInfo_9, set_userInfo_9] = React.useState(0)
const [userInfo_10, set_userInfo_10] = React.useState(0)
const [userInfo_11, set_userInfo_11] = React.useState(0)
const [userInfo_12, set_userInfo_12] = React.useState(0)
const [userInfo_13, set_userInfo_13] = React.useState(0)
const [userInfo_14, set_userInfo_14] = React.useState(0)
const [userInfo_15, set_userInfo_15] = React.useState(0)
const [userInfo_16, set_userInfo_16] = React.useState(0)
const [userInfo_17, set_userInfo_17] = React.useState(0)
const [userInfo_18, set_userInfo_18] = React.useState(0)
const [userInfo_19, set_userInfo_19] = React.useState(0)
const [userInfo_20, set_userInfo_20] = React.useState(0)
const [userInfo_21, set_userInfo_21] = React.useState(0)
const [userInfo_22, set_userInfo_22] = React.useState(0)
const [userInfo_23, set_userInfo_23] = React.useState(0)
const [userBalance_0, set_userBalance_0] = React.useState(0)
const [userBalance_1, set_userBalance_1] = React.useState(0)
const [userBalance_2, set_userBalance_2] = React.useState(0)
const [userBalance_3, set_userBalance_3] = React.useState(0)
const [userBalance_4, set_userBalance_4] = React.useState(0)
const [userBalance_5, set_userBalance_5] = React.useState(0)
const [userBalance_6, set_userBalance_6] = React.useState(0)
const [userBalance_7, set_userBalance_7] = React.useState(0)
const [userBalance_8, set_userBalance_8] = React.useState(0)
const [userBalance_9, set_userBalance_9] = React.useState(0)
const [userBalance_10, set_userBalance_10] = React.useState(0)
const [userBalance_11, set_userBalance_11] = React.useState(0)
const [userBalance_12, set_userBalance_12] = React.useState(0)
const [userBalance_13, set_userBalance_13] = React.useState(0)
const [userBalance_14, set_userBalance_14] = React.useState(0)
const [userBalance_15, set_userBalance_15] = React.useState(0)
const [userBalance_16, set_userBalance_16] = React.useState(0)
const [userBalance_17, set_userBalance_17] = React.useState(0)
const [userBalance_18, set_userBalance_18] = React.useState(0)
const [userBalance_19, set_userBalance_19] = React.useState(0)
const [userBalance_20, set_userBalance_20] = React.useState(0)
const [userBalance_21, set_userBalance_21] = React.useState(0)
const [userBalance_22, set_userBalance_22] = React.useState(0)
const [userBalance_23, set_userBalance_23] = React.useState(0)

const [pool_pendingRewards_0, set_pool_pendingRewards_0] = React.useState(0)
const [pool_pendingRewards_1, set_pool_pendingRewards_1] = React.useState(0)
const [pool_pendingRewards_2, set_pool_pendingRewards_2] = React.useState(0)
const [pool_pendingRewards_3, set_pool_pendingRewards_3] = React.useState(0)
const [pool_pendingRewards_4, set_pool_pendingRewards_4] = React.useState(0)
const [pool_pendingRewards_5, set_pool_pendingRewards_5] = React.useState(0)
const [pool_pendingRewards_6, set_pool_pendingRewards_6] = React.useState(0)
const [pool_pendingRewards_7, set_pool_pendingRewards_7] = React.useState(0)
const [pool_pendingRewards_8, set_pool_pendingRewards_8] = React.useState(0)
const [pool_pendingRewards_9, set_pool_pendingRewards_9] = React.useState(0)
const [pool_pendingRewards_10, set_pool_pendingRewards_10] = React.useState(0)
const [pool_pendingRewards_11, set_pool_pendingRewards_11] = React.useState(0)
const [pool_pendingRewards_12, set_pool_pendingRewards_12] = React.useState(0)
const [pool_pendingRewards_13, set_pool_pendingRewards_13] = React.useState(0)
const [pool_pendingRewards_14, set_pool_pendingRewards_14] = React.useState(0)
const [pool_pendingRewards_15, set_pool_pendingRewards_15] = React.useState(0)
const [pool_pendingRewards_16, set_pool_pendingRewards_16] = React.useState(0)
const [pool_pendingRewards_17, set_pool_pendingRewards_17] = React.useState(0)
const [pool_pendingRewards_18, set_pool_pendingRewards_18] = React.useState(0)
const [pool_pendingRewards_19, set_pool_pendingRewards_19] = React.useState(0)
const [pool_pendingRewards_20, set_pool_pendingRewards_20] = React.useState(0)
const [pool_pendingRewards_21, set_pool_pendingRewards_21] = React.useState(0)
const [pool_pendingRewards_22, set_pool_pendingRewards_22] = React.useState(0)
const [pool_pendingRewards_23, set_pool_pendingRewards_23] = React.useState(0)



const [hubble_price, set_hubble_price] = React.useState(0)
const [activePool, setActivePool] = React.useState(999)
const [stsBalance, setStsBalance] = React.useState(0)
	const [exBalance, setExBalance] = React.useState(0)
	const [xexBalance, setXexBalance] = React.useState(0)

	const [vestXEXCount, setVestXEXCount] = React.useState(0)
	const [activeXEXVest, setActiveXEXVest] = React.useState(0)
	const [vestXEXInfo, setVestXEXInfo] = React.useState({amt:0,start:0,end:0,id:0})

const [hubblerRemainingDiscounts, setHubblerRemainingDiscounts] = React.useState(0)
const [ogRemainingDiscounts, setOgRemainingDiscounts] = React.useState(0)

const [hubblerMints, setTotalHubblerMints] = React.useState(0)
const [ogMints, setTotalOgMints] = React.useState(0)
const [isMintingOG, setIsMintingOG] = React.useState(false)
const [isMintingHubbler, setIsMintingHubbler] = React.useState(false)
const [isAnOg, setIsAnOg] = React.useState(false)
const [hubbleCirculating, setHubbleCirculating] = React.useState(7000)

const [exMints, setExMints] = React.useState(0)
const [remainingMints, setRemainingMints] = React.useState(0)
const [isMinting, setIsMinting] = React.useState(false)
	const HUBBLE = new web3.eth.Contract(
		networkConfig["hubble"]["abi"], 
		networkConfig["hubble"]["address"])
	const xHUBBLE = new web3.eth.Contract(
		networkConfig["xhubble"]["abi"], 
		networkConfig["xhubble"]["address"])
	const wl = new web3.eth.Contract(
		networkConfig["wl"]["abi"], 
		networkConfig["wl"]["address"])
	const MC = new web3.eth.Contract(
		networkConfig["mc"]["abi"], 
		networkConfig["mc"]["address"])
	const VotingModule = new web3.eth.Contract(
		networkConfig["vm"]["abi"], 
		networkConfig["vm"]["address"])
	const RewardModule = new web3.eth.Contract(
		networkConfig["rm"]["abi"], 
		networkConfig["rm"]["address"])
	const Genesis = new web3.eth.Contract(
		networkConfig["genesis"]["abi"], 
		networkConfig["genesis"]["address"]) 
	const STS = new web3.eth.Contract(
		networkConfig["sts"]["abi"], 
		networkConfig["sts"]["address"])

	const EXMINT = new web3.eth.Contract(
		networkConfig["exmint"]["abi"], 
		networkConfig["exmint"]["address"])

	const EX = new web3.eth.Contract(
		networkConfig["ex"]["abi"], 
		networkConfig["ex"]["address"])
	const XEX = new web3.eth.Contract(
		networkConfig["xex"]["abi"], 
		networkConfig["xex"]["address"])
		const EX121 = new web3.eth.Contract(
		networkConfig["ex121"]["abi"], 
		networkConfig["ex121"]["address"])



     const exMintRef = React.createRef(null)
	const hubbleRef = React.createRef(null)
	const unlockRef = React.createRef(null)
	const vestRef = React.createRef(null)
	const wlRef = React.createRef(null)

	const stakeRef = React.createRef(null)
	const unstakeRef = React.createRef(null)

    const exRef = React.createRef(null)
    const xexRef = React.createRef(null)
    const vestXEXRef = React.createRef(null)

const stakeRef_0 = React.createRef(null)
const stakeRef_1 = React.createRef(null)
const stakeRef_2 = React.createRef(null)
const stakeRef_3 = React.createRef(null)
const stakeRef_4 = React.createRef(null)
const stakeRef_5 = React.createRef(null)
const stakeRef_6 = React.createRef(null)
const stakeRef_7 = React.createRef(null)
const stakeRef_8 = React.createRef(null)
const stakeRef_9 = React.createRef(null)
const stakeRef_10 = React.createRef(null)
const stakeRef_11 = React.createRef(null)
const stakeRef_12 = React.createRef(null)
const stakeRef_13 = React.createRef(null)
const stakeRef_14 = React.createRef(null)
const stakeRef_15 = React.createRef(null)
const stakeRef_16 = React.createRef(null)
const stakeRef_17 = React.createRef(null)
const stakeRef_18 = React.createRef(null)
const stakeRef_19 = React.createRef(null)
const stakeRef_20 = React.createRef(null)
const stakeRef_21 = React.createRef(null)
const stakeRef_22 = React.createRef(null)
const stakeRef_23 = React.createRef(null)

const unstakeRef_0 = React.createRef(null)
const unstakeRef_1 = React.createRef(null)
const unstakeRef_2 = React.createRef(null)
const unstakeRef_3 = React.createRef(null)
const unstakeRef_4 = React.createRef(null)
const unstakeRef_5 = React.createRef(null)
const unstakeRef_6 = React.createRef(null)
const unstakeRef_7 = React.createRef(null)
const unstakeRef_8 = React.createRef(null)
const unstakeRef_9 = React.createRef(null)
const unstakeRef_10 = React.createRef(null)
const unstakeRef_11 = React.createRef(null)
const unstakeRef_12 = React.createRef(null)
const unstakeRef_13 = React.createRef(null)
const unstakeRef_14 = React.createRef(null)
const unstakeRef_15 = React.createRef(null)
const unstakeRef_16 = React.createRef(null)
const unstakeRef_17 = React.createRef(null)
const unstakeRef_18 = React.createRef(null)
const unstakeRef_19 = React.createRef(null)
const unstakeRef_20 = React.createRef(null)
const unstakeRef_21 = React.createRef(null)
const unstakeRef_22 = React.createRef(null)
const unstakeRef_23 = React.createRef(null)

const [allPrices, setAllPrices] = React.useState({"0x9ff1b68f8bedf4665fe358f92c3e9af386cb295f":{"price":"7388055624863.544","name":"USDC.e-HUBBLE"},"0x17af1df44444ab9091622e4aa66db5bb34e51ad5":{"price":"0.12409837045431577","name":"Tin Hat Cat"},"0x7a08bf5304094ca4c7b4132ef62b5edc4a3478b7":{"price":"0.2624062129697565","name":"SonicEco"},"0x9990de39ca46151150e392ca96eb349d0f549166":{"price":"1.7690289441662323e-7","name":"SuperSonicSpeedDemon"},"0x50bc6e1dff8039a4b967c1bf507ba5ea13fa18b6":{"price":"0.013801853895152195","name":"sDOG"},"0xe569821a7b621cc16c447c19297089b7205a6d30":{"price":"0.00007524634985710236","name":"Poor"},"0x893a5f9ca92ca721089b6dab44949dbd70cbc711":{"price":"0.000094079006308911","name":"Sonichu"},"0xe5da20f15420ad15de0fa650600afc998bbe3955":{"price":"0.5158517420041531","name":"Liquid Staked Sonic"},"0x9fdbc3f8abc05fa8f3ad3c17d2f806c1230c4564":{"price":"0.1638777660276048","name":"GOGGLES"},"0x94b999e05d1361a802ad6690c1b1ae3426a4e1a6":{"price":"8.4826046697271","name":"Sonic IndeX"},"0xf2fc4c21f1b69fd4b633b4be532deded6ab68715":{"price":"4.253424096616608e-7","name":"YE On Chain"},"0xbee65e9af970ef637a84293d238db4528a53bb47":{"price":"0.0000856209824658519","name":"Solidex Monkey"},"0xe4a4353cd8f008f1a70f1a564535990479e8ceb7":{"price":"0.24098585104987458","name":"Paladin Token"},"0x068e9e009fda970fa953e1f6a43d982ca991f4ba":{"price":"0.04105655182145444","name":"Whale"},"0x486b6fa0419b33a0c7a6e4698c231d7e2f2d5299":{"price":"0.002506225411141804","name":"Moon Bay"},"0xffc05d77e021f12878644537398160a54e33b5e4":{"price":"0.058858958367131314","name":"Candle Token"},"0x3333111a391cc08fa51353e9195526a70b333333":{"price":"64.07470010212361","name":"Shadow Liquid Staking Token"},"0x9bcea390ff97e0d3362bf726820776a4df8add9a":{"price":"0.0002799945183507047","name":"Uppies"},"0x6fb9897896fe5d05025eb43306675727887d0b7c":{"price":"0.007667516104210945","name":"HEDGY the hedgehog"},"0xe920d1da9a4d59126dc35996ea242d60efca1304":{"price":"0.011819987983119284","name":"Derp Token"},"0x38628cb4cc74cbdfb6ddd877b17c1f60fcae7c2c":{"price":"0.0037848402796648944","name":"BLACKHOLE"},"0x4eec869d847a6d13b0f6d1733c5dec0d1e741b4f":{"price":"0.01673604972061058","name":"Indi"},"0xf1c9b8171bf3902554e791010ccbcd6bacba6efd":{"price":"0.00007104675943346384","name":"BEARZWIFGUNZ180042069"},"0x873e509a21b106937472834201d653ba62951c7e":{"price":"0.0000752437726051046","name":"Shrimp Token"}})
const annualizedEmissions = [65700, 32850, 4384.500999, 6509.911637, 4535.095586, 3891.259753, 3863.359604, 3838.630868, 4375.776598, 2057.515371, 1527.778751, 3388.125836, 1571.429573, 1877.478248, 1912.596209, 1557.570437, 1928.820673, 1679.236149, 3650.993175, 1652.678957, 2377.150986, 1568.2467, 1583.480157, 1953.363733]

	  React.useEffect(
	  	() => {
	  		if (isConnected) {
	  			getBal(HUBBLE,(a)=>{
	  				setHubbleBalance(a)
	  				getBal(xHUBBLE,(b)=>{
	  					setXHubbleBalance(b)
	  					setActiveStep(1)
	  					getNewExData()
	  					getFrontData()
	  				})

	  				fetchPrice(HUBBLE.options.address,(json)=>{
	  		
	  					set_hubble_price(json.price)
	  			
	  				})
	  			})
	  		}
	  	},
	  	[isConnected]
	  	)
	React.useEffect(()=>{
		if (activeStep == 2) {
			getVestCount()
			getVestXEXCount()
		} else if (activeStep == 4) {
			gexData()
		}
		else if (activeStep == 5) {
			fetchAllPrices()
			
			fetchPrice(HUBBLE.options.address,(json)=>{
	  		
	  					set_hubble_price(json.price)
	  			
	  				})
			requestChain()
		}
		else if (activeStep == 3) {
			getMcBalance()
			getMcRewards()
		}
	},[activeStep])
	React.useEffect(()=>{
		if(isConnected) {
			getVestInfo(activeVest)
		}
		
	},[vestCount, activeVest])


React.useEffect(()=>{
	if (activePool != 999) {
		getActivePoolData()
		getPendingRewards()
	}
},[activePool])
	
React.useEffect(()=>{
		if(isConnected) {
			getVestXEXInfo(activeXEXVest)
		}
		
	},[vestXEXCount, activeXEXVest])
const [mintingAmount, setMintingAmount] = React.useState(0)
React.useEffect(()=>{
	if (isMinting) {
		setMintingAmount(Number(exMintRef.current.value))
	}

},[isMinting])
	
	const estimateGas = (contract, data, callback = ()=>{}) => {
		if (typeof window.ethereum !== 'object') {
			alert("Please open this page in the Metamask browser")
		} 
		else {
			window.ethereum.request(
		        {
		          method: "eth_estimateGas",
		          params: [
		            {
		              from: address,
		              to: contract,     
		              value: web3.utils.toHex(0),
		              data: data,
		            },
		          ],
		        }
		      ).then((gasAmount)=>{
		      	console.log(gasAmount)
		        callback(gasAmount)
		      }).catch((err)=>{
		        alert(err.data.message)
		      })
		}
	}
	const sendRequest = (contract, data, callback = ()=>{}) => {
		estimateGas(
			contract,
			data,
			() => {
				setIsPending(true)
				if (typeof window.ethereum !== 'object') { 
				
				} else {
					window.ethereum.request({
						method: "eth_sendTransaction",
						params: [
						  {
						    from: address,
						    to: contract,
						    value: 0,
						    data: data,
						  },
						],}).then((hash)=>{
						  getTransactionReceipt(hash,(receipt)=>{
						    if (receipt != null) {
						      setIsPending(false)
						      callback()
						    }
						  })
						}).catch((err)=>{
						  setIsPending(false)
						})	
					}		
			}
			)
	}


const getBal = (contract, callback = ()=>{}) => {
	contract.methods.balanceOf(address)
		.call({from: address})
		.then((bal)=>{
			callback(bal)
		})
}
const checkAllowance = (contract, spender, amount, callback = ()=>{}) =>{
	contract.methods.allowance(address, spender)
		.call({from: address})
		.then((allowance)=>{
			callback(allowance)
		})
}

const approve = (contract, spender, amount, callback = ()=>{}) => {

	let data = contract.methods.approve(spender,amount).encodeABI()
	sendRequest(
		contract.options.address,
		data,
		callback)
}

const mintHubble = () => {
	let data = HUBBLE.methods.mint().encodeABI()
	setPendingText("Minting 42 $HUBBLE on testnet")

	sendRequest(
		HUBBLE.options.address,
		data,
		()=>{
			getBal(HUBBLE,(bal)=>{
				setHubbleBalance(bal)
			})
		})
		
		
	
}

const lock = () => {
	if (Number(hubbleRef.current.value) == 0) {
		alert("Enter a nonzero value")
	}
	else {
		let amt = web3.utils.toWei(hubbleRef.current.value,"ether")
		let data = xHUBBLE.methods.lock(amt).encodeABI()

		checkAllowance(
			HUBBLE,
			xHUBBLE.options.address,
			amt,
			(allowance) => {
				let alw = web3.utils.fromWei(allowance,"ether")
				if (alw >= Number(hubbleRef.current.value)) {
					setPendingText("Locking $HUBBLE")
					sendRequest(
						xHUBBLE.options.address,
						data,
						()=>{
							getBal(HUBBLE,(bal)=>{
								setHubbleBalance(bal)
							})
							getBal(xHUBBLE,(bal)=>{
								setXHubbleBalance(bal)
							})
						})
				} 
				else {
					setPendingText("Approving your HUBBLE for use by the xHUBBLE contract.")
					approve(
						HUBBLE,
						xHUBBLE.options.address,
						amt,
						()=>{
							setPendingText("Locking $HUBBLE")
							sendRequest(
							xHUBBLE.options.address,
							data,
							()=>{
								getBal(HUBBLE,(bal)=>{
									setHubbleBalance(bal)
								})
								getBal(xHUBBLE,(bal)=>{
									setXHubbleBalance(bal)
								})	
							})
						}
						)
				} 
			}
			)
}
	
}
const earlyExit = () => {
	if (Number(unlockRef.current.value) == 0) {
		alert("Enter a nonzero value")
	}
	else {
		let amt = web3.utils.toWei(unlockRef.current.value,"ether")
		let data = xHUBBLE.methods.crash(amt).encodeABI()
		setPendingText("Crashing out your $xHUBBLE for $HUBBLE!?!!")
		sendRequest(
			xHUBBLE.options.address,
			data,
			()=>{
				getBal(HUBBLE,(bal)=>{
					setHubbleBalance(bal)
				})
				getBal(xHUBBLE,(bal)=>{
					setXHubbleBalance(bal)
				})
			})
	}
	
}
const getVestCount = () => {
	xHUBBLE.methods.usersTotalVests(address)
		.call({from: address})
		.then((count)=>{
			setVestCount(count)
		})
}
const getVestInfo = (index) => {
	xHUBBLE.methods.vestInfo(address,index)
		.call({from: address})
		.then((output)=>{
			setVestInfo({
				amt: Number(output.amount),
				start: Number(output.start),
				end: Number(output.maxEnd),
				id: Number(output.vestID)
			})
			console.log(output)
		})
}
const vest = () => {
	if (Number(vestRef.current.value) == 0) {
		alert("Enter a nonzero value")
	}
	else {
		let amt = web3.utils.toWei(vestRef.current.value,"ether")
		let data = xHUBBLE.methods.createVest(amt).encodeABI()
		setPendingText("Vesting your $xHUBBLE for $HUBBLE... see you in 180 days!")
		sendRequest(
			xHUBBLE.options.address,
			data,
			()=>{
				getBal(HUBBLE,(bal)=>{
					setHubbleBalance(bal)
				})
				getBal(xHUBBLE,(bal)=>{
					setXHubbleBalance(bal)
					getVestCount()
				})
			})
	}
}

const HubbleIcon = ()=>(<div className="icon icon--hubble"><img src={dd}/></div>)
const XhubbleIcon = ()=>(<div className="icon icon--xhubble"><img src={xi}/></div>)
const McIcon = ()=>(<div className="icon icon--mc"><img src={mc}/></div>)
const prevVest = () => {
	if (activeVest > 0) {
		setActiveVest(activeVest - 1)
	}
	
}

const nextVest = () => {
	if (activeVest < Number(vestCount) -  1) {
		setActiveVest(activeVest + 1)
	}
	
}

const getTotalSubmissions = (callback=()=>{}) => {
	wl.methods.totalSubmissions()
		.call({from: address})
		.then((count)=>{
			setTotalSubmissions(count)
			callback()
		})
}

const getUserSubmissionCount = (callback=()=>{})=>{
	wl.methods.submissionCountByUser(address)
		.call({from: address})
		.then((count)=>{
			setWlCount(count)
			callback()
		})
}

const submitForWhitelist = () => {
	
	
	if (!web3.utils.isAddress(wlRef.current.value)) {
		alert("ERROR: please submit a valid address")
	} 
	else {
		alert("You will be required to keep 42 xHUBBLE throughout genesis or this pool's emissions will turn off.")
		let addy = wlRef.current.value
	let token = new web3.eth.Contract(
		networkConfig["hubble"]["abi"], 
		addy)
	let data = wl.methods.submit(addy).encodeABI()
		checkAllowance(
		token,
		wl.options.address,
		1,
		(allowance) => {
			
			if (allowance >= 1) {
				setPendingText("Submitting your token")
				sendRequest(
					wl.options.address,
					data,
					()=>{
						getTotalSubmissions(getUserSubmissionCount(getTheList))
						
					})
			} 
			else {
				setPendingText("Approving a small amount of your token to send to the whitelist contract");
				approve(
					token,
					wl.options.address,
					1,
					()=>{
						setPendingText("Submitting your token")
						sendRequest(
						wl.options.address,
						data,
						()=>{
							getTotalSubmissions(getUserSubmissionCount(getTheList))
						})
					}
					)
			} 
		}
		)
	} 
	
}

const getTheList = (callback = ()=>{}) => {
	wl.methods.fetchSubmissions()
		.call({from: address})
		.then((wls)=>{
			setTheList(wls)
			callback()
		})
}

const getTheNames = (callback = ()=>{}) => {
	wl.methods.fetchNames()
		.call({from: address})
		.then((wls)=>{
			setTheNames(wls)
			callback()
		})
}

const getTheSymbols = (callback = ()=>{}) => {
	wl.methods.fetchSymbols()
		.call({from: address})
		.then((wls)=>{
			setTheSymbols(wls)
			callback()
		})
}

const exitVest = (callback = ()=>{}) =>{
	console.log(vestInfo)
	let data = xHUBBLE.methods.exitVest(Number(vestInfo.id)).encodeABI()
	setPendingText("Exiting your Vest. Please be sure you understand what this means!")
	sendRequest(
		xHUBBLE.options.address,
		data,
		()=>{
			callback()
			getVestCount()
			getVestInfo()
			getBal(HUBBLE,(bal)=>{
				setHubbleBalance(bal)
			})
			getBal(xHUBBLE,(bal)=>{
				setXHubbleBalance(bal)
			})
		}
		)
}

// -------------------------------------
// Mission Control

const getMcBalance = () => {
	MC.methods.balanceOf(address)
		.call({from: address})
		.then((bal)=>{
			setMcBalance(bal)
		})
}

const stakeMC = (amt,callback = ()=>{}) => {
	let data = MC.methods.stake(amt).encodeABI()
	setPendingText("Staking your xHUBBLE")
	
	sendRequest(
		MC.options.address,
		data,
		()=>{
			getBal(xHUBBLE,
				(bal)=>{
					setXHubbleBalance(bal)
					getMcBalance()
					callback()
				})
			
		}
		)
}

const unstakeMC = (callback = ()=>{}) => {
	let data = MC.methods.withdraw(web3.utils.toWei(unstakeRef.current.value,"ether")).encodeABI()
	setPendingText("Unstaking your xHUBBLE")
	
	sendRequest(
		MC.options.address,
		data,
		()=>{
			getBal(xHUBBLE,
				(bal)=>{
					setXHubbleBalance(bal)
					getMcBalance()
					callback()
				})
			
		}
		)
}


const stake = () => {
	// check allowance of MC to spend xHUBBLE
	// approve if necessary
	// stake
	let amt = web3.utils.toWei(stakeRef.current.value,"ether")

	checkAllowance(
		xHUBBLE,
		MC.options.address,
		amt,
		(allowance)=>{
			if (web3.utils.fromWei(allowance,"ether") < Number(stakeRef.current.value)) {
				// approve 
				setPendingText("Approving Mission Control as a spender of your xHUBBLE")
				approve(
					xHUBBLE,
					MC.options.address,
					amt,
					() => {
						stakeMC(amt)
					}

					
					
					)
			}
			else {
				stakeMC(amt)
			}
		}
		)
}
const unstake = () => {

	unstakeMC()
}
// ------------------------------------------------------------------------------------------------------


const toggleMobileNav = () => {
	if(navMobileToggle) {
		setNavMobileToggle(false)
	}
	else {
		setNavMobileToggle(true)
	}
}

const viewRewards = () => {
	console.log(RewardModule.options.address)
	RewardModule.methods.viewPendingRewards(address,"0x29219dd400f2bf60e5a23d13be72b486d4038894")
		.call({from: address})
		.then((pendingRewards1)=>{
			
			setMcNCR_1(Number(pendingRewards1)/1e6)
			RewardModule.methods.viewPendingRewards(address,xHUBBLE.options.address)
				.call({from: address})
				.then((pendingRewards2)=>{
					console.log(pendingRewards2)
					setMcCriticalRewards(web3.utils.fromWei(pendingRewards2,"ether"))
					RewardModule.methods.viewPendingRewards(address,HUBBLE.options.address)
						.call({from: address})
						.then((pendingRewards3)=>{
							
							setMcNCR_2(web3.utils.fromWei(pendingRewards3, "ether"))
							
				})
				})
		})
}

const getMcRewards = () => {
	console.log("getting rewards")

	
	viewRewards()

	
}

const claimCriticalRewards = () => {
	let data = MC.methods.claimCriticalRewards().encodeABI()
	setPendingText("Claiming xHUBBLE")
	sendRequest(
		MC.options.address,
		data,
		()=>{
			getMcRewards()
			getBal(xHUBBLE,
				(bal)=>{
					setXHubbleBalance(bal)
				})
		}
		)
}

const claimNCRewards = () => {
	let data = MC.methods.claimNonCriticalRewards().encodeABI()
	setPendingText("Claiming Rewards")
	sendRequest(
		MC.options.address,
		data,
		()=>{
			getMcRewards()
			
		}
		);
}

const claimUSDCRewards = () => {
	let data = RewardModule.methods.claimNonCriticalReward(address, USDC).encodeABI()
	setPendingText("Claiming USDC Rewards")
	sendRequest(
		RewardModule.options.address,
		data,
		()=>{
			getMcRewards()
			
		}
		);
}
const claimHubbleRewards = () => {
	let data = RewardModule.methods.claimNonCriticalReward(address, HUBBLE.options.address).encodeABI()
	setPendingText("Claiming HUBBLE Rewards")
	sendRequest(
		RewardModule.options.address,
		data,
		()=>{
			getMcRewards()
			
		}
		);
}
const [totalStaked, setTotalStaked] = React.useState(1)
const getTotalStaked = () => {
	MC.methods.totalSupply()
		.call({from: address})
		.then((supply)=>{
			setTotalStaked(supply)
		})
}

const fetchPrice = (tokenAddress, callback = ()=>{}) => {
	const baseUrl = "https://www.hubble-server.xyz:1443/price";
  	const url = `${baseUrl}?token=${tokenAddress}`;
  	fetch(url)
  		.then((response)=>{
			//console.log(response)
			response.json()
				.then((json) =>{
					//console.log(json)
					callback(json)
				})
			})
}

const fetchAllPrices = (callback = ()=>{}) => {
	const baseUrl = "https://www.hubble-server.xyz:1443/all-prices";
  	fetch(baseUrl)
  		.then((response)=>{
			response.json()
				.then((json) =>{
					console.log(json)
					setAllPrices(json)
				})
			})
}

const fetchPrices = () => {
	for(let i = 1; i < 24; i++) {
		fetchPrice(pools[i].address,(json)=>{
			eval('set_pool_tokenPrice_'+i+'('+json.price+')')
		}
			)
	}
}

// apr = annual emissions / tvl
// tvl = price of token * balance of token

const getPoolInfo = (pid,callback = () =>{}) => {
	Genesis.methods.poolInfo(pid)
		.call({from: address})
		.then((poolInfo)=>{
			callback(poolInfo)
		})
}

const getTotalTokens = (pid, callback = ()=>{}) => {
	const contract = new web3.eth.Contract(
		networkConfig["hubble"]["abi"], 
		pools[pid].address)
//	console.log(`checking balance of ${pools[pid].name}`)
	contract.methods.balanceOf(Genesis.options.address)
		.call({from: address})
		.then((bal)=>{
			
			console.log(`balance of ${pools[pid].name}: ${bal}`)
			eval('set_pool_totalTokens_'+pid+'('+web3.utils.fromWei(bal,"ether")+')')
			callback(bal)
		})
}

const getLPValue = () => {
	const contract = new web3.eth.Contract(
		networkConfig["hubble"]["abi"], 
		pools[0].address)

	contract.methods.totalSupply()
		.call({from: address})
		.then((totalSupplyOfLP)=>{
			HUBBLE.methods.balanceOf(pools[0].address)
				.call({from: address})
				.then((hubbleInLP)=>{
					console.log(`lp has this much hubble: ${hubbleInLP}`)
					console.log(`hubble price is: ${hubble_price}`)
					let tvl = Number(web3.utils.fromWei(hubbleInLP,"ether")) * Number(hubble_price) * 2 
					console.log(`this is the tvl: ${tvl}`)
					let price = tvl / Number(web3.utils.fromWei(totalSupplyOfLP,"ether"))
					set_pool_tokenPrice_0(price)
				})
			
		})
}

const getUserInfo = (pid, callback = ()=>{}) => {
	Genesis.methods.userInfo(pid,address)
		.call({from:address})
		.then((userInfo)=>{
			eval(`set_userInfo_${pid}(${userInfo.amount})`)
			callback(userInfo)
		})
}

const requestChain = ()=>{

	getTotalTokens(0,
		getTotalTokens(1,
			getTotalTokens(2,
				getTotalTokens(3,
					getTotalTokens(4,
						getTotalTokens(5,
							getTotalTokens(6,
								getTotalTokens(7,
									getTotalTokens(8,
										getTotalTokens(9,
											getTotalTokens(10,
												getTotalTokens(11,
													getTotalTokens(12,
														getTotalTokens(13,
															getTotalTokens(14,
																getTotalTokens(15,
																	getTotalTokens(16,
																		getTotalTokens(17,
																			getTotalTokens(18,
																				getTotalTokens(19,
																					getTotalTokens(20,
																						getTotalTokens(21,
																							getTotalTokens(22,
																								getTotalTokens(23))))))))))))))))))))))))
	getUserInfo(0,
		getUserInfo(1,
			getUserInfo(2,
				getUserInfo(3,
					getUserInfo(4,
						getUserInfo(5,
							getUserInfo(6,
								getUserInfo(7,
									getUserInfo(8,
										getUserInfo(9,
											getUserInfo(10,
												getUserInfo(11,
													getUserInfo(12,
														getUserInfo(13,
															getUserInfo(14,
																getUserInfo(15,
																	getUserInfo(16,
																		getUserInfo(17,
																			getUserInfo(18,
																				getUserInfo(19,
																					getUserInfo(20,
																						getUserInfo(21,
																							getUserInfo(22,
																								getUserInfo(23))))))))))))))))))))))))
	

}


const managePool = (pid) => {
	return ()=>{
		let p = pid
		setActivePool(pid)

	}
}


const closePoolModal = () => {

	setActivePool(999)
	
}

const getActivePoolData = () => {
	const contract = new web3.eth.Contract(
		networkConfig["hubble"]["abi"], 
		pools[activePool].address)
	getBal(contract,(bal)=>{
		eval(`set_userBalance_${activePool}(${bal})`)
	})
}

const setRefToThis = (setToThis,theRef) => {
	return () => {
		console.log(setToThis)
		theRef.current.value = setToThis
	}
	
}

const deposit = (pid,amt,callback=()=>{}) => {
	let data = Genesis.methods.deposit(pid,amt).encodeABI()
	setPendingText(`Depositing your ${pools[pid].symbol} to the Genesis Pool`)
	sendRequest(
		Genesis.options.address,
		data,
		() => {
			callback()
			getUserInfo(pid)
			getActivePoolData()
		}
		)
}

const stakeGenesis = (index) => {
	return () => {
		let pool = pools[index]
		let amt = web3.utils.toWei(eval(`stakeRef_${index}.current.value`),"ether")
		const contract = new web3.eth.Contract(
			networkConfig["hubble"]["abi"], 
			pool.address)
		checkAllowance(
			contract,
			Genesis.options.address,
			amt,
			(allowance)=>{
				if (web3.utils.fromWei(allowance,"ether") >= eval(`stakeRef_${index}.current.value`)) {
					deposit(index,amt)
				}
				else {
					setPendingText(`Approving Genesis Contract to spend your ${pool.symbol}`)
					approve(
						contract,
						Genesis.options.address,
						amt,
						() => {
							deposit(index,amt)
						})
				}
			})
	}
}

const unstakeGenesis = (index) => {
	return () => {
		let pool = pools[index]
		let amt =  web3.utils.toWei(eval(`unstakeRef_${index}.current.value`),"ether")
		let data = Genesis.methods.withdraw(index,amt).encodeABI()
		setPendingText(`Withdrawing ${pool.symbol}`)
		sendRequest(
			Genesis.options.address,
			data,
			()=>{
				getUserInfo(index)
				getActivePoolData()
			}
			)
	}
}

const priceOf = (tokenAddress) => {
	if (typeof(allPrices[tokenAddress.toLowerCase()]) == 'undefined') return 0
	else return allPrices[tokenAddress.toLowerCase()].price
}

const claimRewards = (pid, callback=()=>{}) => {
	return ()=>{
		let data = Genesis.methods.deposit(pid,0).encodeABI()
		setPendingText(`Claiming your rewards`)
		sendRequest(
			Genesis.options.address,
			data,
			() => {
				
				getActivePoolData()
				callback()
			}
			)
	}
}

const getPendingRewards = () => {

		Genesis.methods.pendingHUBBLE(activePool,address)
			.call({from: address})
			.then((pr)=>{
				let prn = web3.utils.fromWei(pr,"ether")
				eval(`set_pool_pendingRewards_${activePool}(${prn})`)
			})
	
}

const claim = (pid, callback=()=>{})=> {
	if (eval(`Number(web3.utils.fromWei(userInfo_${pid},"ether"))`) > 0) {
		let data = Genesis.methods.deposit(pid,0).encodeABI()
		setPendingText(`Claiming your rewards for ${pools[pid].name}`)
		sendRequest(
				Genesis.options.address,
				data,
				() => {
					
					getActivePoolData()
					callback()
				}
				)
	} else {
		callback()
	}
}
const claimAll = () => {
	claim(0,claim(1,claim(2,claim(3,claim(4, claim(5,claim(6,claim(7,claim(8,claim(9,claim(10,claim(11,claim(12,claim(13,claim(14,claim(15,claim(16,claim(17,claim(18,claim(19,claim(20,claim(21,claim(22,claim(23))))))))))))))))))))))))
}


const getV1Bal= (addy, callback=()=>{})=>{
	MC.methods.balanceOf(addy)
		.call({from: address})
		.then((mcb)=>{
			callback(mcb)
			console.log(addy,mcb)
		})
}



	const gexData = () => {
	EX121.methods.remainingMints(address)
		.call({from: address})
		.then((rm)=>{
			setRemainingMints(rm)
			EX121.methods.mints(address)
				.call({from: address})
				.then((rex)=>{
					setExMints(rex)
				})
		})

}












const lockEx = () => {
	if (Number(exRef.current.value) == 0) {
		alert("Enter a nonzero value")
	}
	else {
		let amt = web3.utils.toWei(exRef.current.value,"ether")
		let data = XEX.methods.lock(amt).encodeABI()

		checkAllowance(
			EX,
			XEX.options.address,
			amt,
			(allowance) => {
				let alw = web3.utils.fromWei(allowance,"ether")
				if (alw >= Number(exRef.current.value)) {
					setPendingText("Locking $EX")
					sendRequest(
						XEX.options.address,
						data,
						()=>{
							getBal(EX,(bal)=>{
								setExBalance(bal)
							})
							getBal(XEX,(bal)=>{
								setXexBalance(bal)
						
							})
						})
				} 
				else {
					setPendingText("Approving your $EX for use by the $xEX contract.")
					approve(
						EX,
						XEX.options.address,
						amt,
						()=>{
							setPendingText("Locking $EX")
							sendRequest(
							XEX.options.address,
							data,
							()=>{
								getBal(EX,(bal)=>{
									setExBalance(bal)
								})
								getBal(XEX,(bal)=>{
									setXexBalance(bal)
							
								})
							})
						}
						)
				} 
			}
			)
}
	
}
const earlyExitXEX = () => {
	if (Number(xexRef.current.value) == 0) {
		alert("Enter a nonzero value")
	}
	else {
		let amt = web3.utils.toWei(xexRef.current.value,"ether")
		let data = XEX.methods.crash(amt).encodeABI()
		setPendingText("Crashing out your $xEX for $EX!?!!")
		sendRequest(
			XEX.options.address,
			data,
			()=>{
				getBal(EX,(bal)=>{
									setExBalance(bal)
								})
								getBal(XEX,(bal)=>{
									setXexBalance(bal)
							
								})
			})
	}
	
}
const vestXEX = () => {
	if (Number(vestXEXRef.current.value) == 0) {
		alert("Enter a nonzero value")
	}
	else {
		let amt = web3.utils.toWei(vestXEXRef.current.value,"ether")
		let data = XEX.methods.createVest(amt).encodeABI()
		setPendingText("Vesting your $xEX for $EX... see you in 14 days!")
		sendRequest(
			XEX.options.address,
			data,
			()=>{
				getBal(EX,(bal)=>{
					setExBalance(bal)

				})
				getBal(XEX,(bal)=>{
					setXexBalance(bal)
			
				})
			})
	}
}
const exitVestXEX = (callback = ()=>{}) =>{
	console.log(vestXEXInfo)
	let data = XEX.methods.exitVest(Number(vestXEXInfo.id)).encodeABI()
	setPendingText("Exiting your Vest. Please be sure you understand what this means!")
	sendRequest(
		XEX.options.address,
		data,
		()=>{
			callback()
			getVestXEXCount()

			getBal(EX,(bal)=>{
					setExBalance(bal)

				})
				getBal(XEX,(bal)=>{
					setXexBalance(bal)
			
				})
		}
		)
}

const prevVestXEX = () => {
	if (activeXEXVest > 0) {
		setActiveVest(activeXEXVest - 1)
	}
	
}

const nextVestXEX = () => {
	if (activeXEXVest < Number(vestXEXCount) -  1) {
		setActiveVest(activeXEXVest + 1)
	}
	
}
const getVestXEXCount = () => {
	console.log("getting ex vests")
	XEX.methods.usersTotalVests(address)
		.call({from: address})
		.then((count)=>{
			setVestXEXCount(count)
		})
}
const getVestXEXInfo = (index) => {
	XEX.methods.vestInfo(address,index)
		.call({from: address})
		.then((output)=>{
			setVestXEXInfo({
				amt: Number(output.amount),
				start: Number(output.start),
				end: Number(output.maxEnd),
				id: Number(output.vestID)
			})
			console.log(output)
		})
}

const getNewExData = () => {
	getBal(
			STS,
			(_sts)=>{
				setStsBalance(_sts)
				getBal(
					EX,
					(_ex)=>{
						setExBalance(_ex)
						getBal(
							XEX,
							(_xex)=>{
								setXexBalance(_xex)
								gexData()
							})
					}
					)
			}
			)
}

const getFrontData = ()=>{
	HUBBLE.methods.balanceOf(xHUBBLE.options.address)
		.call({from: address})
		.then((hubbleLocked)=>{
			let hubbleLockedNum = Number(web3.utils.fromWei(hubbleLocked,"ether"))
	
			HUBBLE.methods.balanceOf("0xd5A638a1E6D55Dee90688e65F15BFA3f08d869A1")
				.call({from: address})
				.then((hubbleReserves)=>{
					let hubbleReservesNum = Number(web3.utils.fromWei(hubbleReserves,"ether"))
					HUBBLE.methods.balanceOf("0x000000000000000000000000000000000000dEaD")
						.call({from: address})
						.then((hubbleDead)=>{
							let hubbleDeadNum = Number(web3.utils.fromWei(hubbleDead,"ether"))
		
							setHubbleCirculating(200000-hubbleLockedNum-hubbleReservesNum-hubbleDeadNum)
						})
				})
		})
}
const mintPopup = ()=>{
	setIsMinting(true)
}
const mint121 = () => {

	setIsMinting(false)
	let amt = web3.utils.toWei(exMintRef.current.value,"ether")
	let numamt = Number(exMintRef.current.value)
	let stsBal = Number(web3.utils.fromWei(stsBalance,"ether"))
	let remaining = Number(web3.utils.fromWei(remainingMints,"ether"))

		if (numamt >= 1) {
	if (numamt <= stsBal) {
		if (numamt <= remaining) {	
			checkAllowance(
				STS,
				EX121.options.address,
				amt,
				(allowance)=>{
					let alw = Number(web3.utils.fromWei(allowance,"ether"))
				 	if (alw >= numamt)  {
				 		alert(`Minting ${numamt} while allowance is ${alw}`)
						_mint(amt)
					}
					else {
						setPendingText(`Approving Minting Contract to spend your stS`)
						approve(
							STS,
							EX121.options.address,
							amt,
							() => {
								_mint(amt)
							})
					}
				})
		} else {
			alert("You do not have enough xHUBBLE. Each xHUBBLE affords a user 10000 mints.")
		}
	}
	else {
		alert("You do not have enough stS")
	}} else {
		alert("You must mint at least 1 $EX")
	}
	 
}
const _mint = (amt)=>{
	let ma = web3.utils.fromWei(amt,"ether")

	let data = EX121.methods.mint(amt).encodeABI()
	setPendingText(`Minting ${ma} EX for ${ma} stS`)
	sendRequest(
		EX121.options.address,
		data,
		() => {

			gexData()
			getNewExData()
		}
		)
}
const closeMint = () =>{
	setIsMinting(false)
}
  return (
  	<div className={"App App--" + isConnected + " App-chain--" + chainId}>
  		<div className="the-back" style={{backgroundImage: `url(${bg})`}}></div>
  		<div className="the-back cover"></div>
	  	<div className="bg" >
	  		<div className="inner">
	  			<div className="inner-inner">
		  			
		  			
		  			<div className={"step step-1 step--"+activeStep}>
		  				<div className="step-title"><img src={dd}/><span>HUBBLE Mainnet</span></div>
		  				<div className="data-tile">
		  					<h3>HUBBLE Circulating Supply</h3>
		  					<p className="data-focus">{Math.round(100*hubbleCirculating)/100} $HUBBLE</p>
		  					<p className="data-item">${Math.round(100*hubble_price*hubbleCirculating)/100}</p>
		  				</div>
		  				<p>Genesis is over.</p>
		  				<p>Exgenesis 1-to-1 Minting is Live at the Galactic Exchange.</p>
		  				<p>Lock HUBBLE to participate.</p>
		  				<h3>Airdrops for xHUBBLE Holders</h3>
		  				<p>April 1st - 1000 USDC</p>
		  				<p>April 2nd - 1000 USDC</p>
		  				<h3>Airdrops for xEX Holders</h3>
		  				<p>April 1st - 16.66 x33 + 222 USDC</p>
		  				<p>April 2nd - TBD</p>
		  			
		  			</div>
		  			<div className={"step step-2 step--"+activeStep}>

		  				<div className="step-title"><img src={xi}/><span>Galactic Bank: Hubble Desk</span></div>
		  				<div className="locker">
		  					<div className="locker-text">
		  						<h2>Convert HUBBLE to xHUBBLE</h2>
		  						<p>Convert HUBBLE to xHUBBLE at any time. The process is instant, and the ratio is 1:1.</p>
		  					</div>
		  					<div className="locker-locker">
		  						<div className="locker-icon">
		  							<div className="hubble-icon">
		  								<img src={dd} />
		  							</div>
		  							<div className="icon-text">
		  								<div className="small">Convert</div>
		  								<div className="large">HUBBLE</div>
		  							</div>
		  						</div>
		  						<div className="locker-input">
		  							<input ref={hubbleRef} placeholder="0"/>
		  							<button className="max-button" onClick={
								  								setRefToThis(
								  									web3.utils.fromWei(hubbleBalance,"ether"),
								  									hubbleRef)}>MAX</button>
		  							<span>Balance: {web3.utils.fromWei(hubbleBalance,"ether")}</span>
		  						</div>
		  						<button onClick={lock}>Lock</button>
		  					</div>
		  				</div>
		  				<div className="locker">
		  					<div className="locker-text">
		  						<h2>Vested Exit</h2>
		  						<p>Redeem xHUBBLE over a 180 day vesting period. You can cancel the vest in the first 14 days.</p>
		  					</div>
		  					<div className="locker-locker">
		  						<div className="locker-icon">
		  							<div className="hubble-icon">
		  								<img src={xi} />
		  							</div>
		  							<div className="icon-text">
		  								<div className="small">Vest</div>
		  								<div className="large">xHUBBLE</div>
		  							</div>
		  						</div>
		  						<div className="locker-input">
		  							<input ref={vestRef} placeholder="0"/>
		  							<button className="max-button" onClick={
								  								setRefToThis(
								  									web3.utils.fromWei(xhubbleBalance,"ether"),
								  									vestRef)}>MAX</button>
		  							<span>Balance: {web3.utils.fromWei(xhubbleBalance,"ether")}</span>
		  						</div>
		  						<button onClick={vest}>Vest</button>
		  					</div>
		  				</div>
		  				<div className="locker">
		  					<div className="locker-text">
		  						<h2>Instant Exit</h2>
		  						<p>Instantly exit to HUBBLE, incurring a 50% penalty. This process cannot be reverted, all forfeited HUBBLE is streamed back to stakers.</p>
		  					</div>
		  					<div className="locker-locker">
		  						<div className="locker-icon">
		  							<div className="hubble-icon">
		  								<img src={xi} />
		  							</div>
		  							<div className="icon-text">
		  								<div className="small">Exit</div>
		  								<div className="large">xHUBBLE</div>
		  							</div>
		  						</div>
		  						<div className="locker-input">
		  							<input ref={unlockRef} placeholder="0"/>
		  							<button className="max-button" onClick={
								  								setRefToThis(
								  									web3.utils.fromWei(xhubbleBalance,"ether"),
								  									unlockRef)}>MAX</button>
		  							<span>Balance: {web3.utils.fromWei(xhubbleBalance,"ether")}</span>
		  						</div>
		  						<button onClick={earlyExit}>Exit</button>
		  					</div>
		  				</div>
		  				<div>
		  					<p>You have {vestCount} vests.</p>
				  			<div className="vest">
				  			 <p>Vest {activeVest}</p> 
				  			 <p>{web3.utils.fromWei(vestInfo.amt,"ether")} <HubbleIcon/></p>
				  			 <p>Vesting for {Math.round((vestInfo.end - Date.now()/1000)/(60 * 60 * 24))} Days</p>
				  			</div>
				  			<p><button onClick={exitVest}>Exit Vest</button></p>
				  			<p><button onClick={prevVest}>Previous Vest</button><button onClick={nextVest}>Next Vest</button></p>
			  			</div>
			  			<div className="step-title"><img src={ex}/><span>Galactic Bank: EX Desk</span></div>
		  				<div className="locker">
		  					<div className="locker-text">
		  						<h2>Convert EX to xEX</h2>
		  						<p>Convert EX to xEX at any time. The process is instant, and the ratio is 1:1.</p>
		  					</div>
		  					<div className="locker-locker">
		  						<div className="locker-icon">
		  							<div className="hubble-icon">
		  								<img src={ex} />
		  							</div>
		  							<div className="icon-text">
		  								<div className="small">Convert</div>
		  								<div className="large">EX</div>
		  							</div>
		  						</div>
		  						<div className="locker-input">
		  							<input ref={exRef} placeholder="0"/>
		  							<button className="max-button" onClick={
								  								setRefToThis(
								  									web3.utils.fromWei(exBalance,"ether"),
								  									exRef)}>MAX</button>
		  							<span>Balance: {web3.utils.fromWei(exBalance,"ether")}</span>
		  						</div>
		  						<button onClick={lockEx}>Lock</button>
		  					</div>
		  				</div>
		  				<div className="locker">
		  					<div className="locker-text">
		  						<h2>Vested Exit</h2>
		  						<p>Redeem xEX over a 14 day vesting period. You can cancel the vest in the first 7 days.</p>
		  					</div>
		  					<div className="locker-locker">
		  						<div className="locker-icon">
		  							<div className="hubble-icon">
		  								<img src={xex} />
		  							</div>
		  							<div className="icon-text">
		  								<div className="small">Vest</div>
		  								<div className="large">xEX</div>
		  							</div>
		  						</div>
		  						<div className="locker-input">
		  							<input ref={vestXEXRef} placeholder="0"/>
		  							<button className="max-button" onClick={
								  								setRefToThis(
								  									web3.utils.fromWei(xexBalance,"ether"),
								  									vestXEXRef)}>MAX</button>
		  							<span>Balance: {web3.utils.fromWei(xexBalance,"ether")}</span>
		  						</div>
		  						<button onClick={vestXEX}>Vest</button>
		  					</div>
		  				</div>
		  				<div className="locker">
		  					<div className="locker-text">
		  						<h2>Instant Exit</h2>
		  						<p>Instantly exit to EX, incurring a 50% penalty. This process cannot be reverted, all forfeited EX is streamed back to stakers.</p>
		  					</div>
		  					<div className="locker-locker">
		  						<div className="locker-icon">
		  							<div className="hubble-icon">
		  								<img src={xex} />
		  							</div>
		  							<div className="icon-text">
		  								<div className="small">Exit</div>
		  								<div className="large">xEX</div>
		  							</div>
		  						</div>
		  						<div className="locker-input">
		  							<input ref={xexRef} placeholder="0"/>
		  							<button className="max-button" onClick={
								  								setRefToThis(
								  									web3.utils.fromWei(xexBalance,"ether"),
								  									xexRef)}>MAX</button>
		  							<span>Balance: {web3.utils.fromWei(xexBalance,"ether")}</span>
		  						</div>
		  						<button onClick={earlyExitXEX}>Exit</button>
		  					</div>
		  				</div>
		  				<div>
		  					<p>You have {vestXEXCount} vests.</p>
				  			<div className="vest">
				  			 <p>Vest {activeXEXVest}</p> 
				  			 <p>{web3.utils.fromWei(vestXEXInfo.amt,"ether")} <div className="icon icon--ex"><img src={ex}/></div></p>
				  			 <p>Vesting for {Math.round((vestXEXInfo.end - Date.now()/1000)/(60 * 60 * 24))} Days</p>
				  			</div>
				  			<p><button onClick={exitVestXEX}>Exit Vest</button></p>
				  			<p><button onClick={prevVestXEX}>Previous Vest</button><button onClick={nextVestXEX}>Next Vest</button></p>
			  			</div>
		  			</div>

		  			<div className={"step step-3 step--"+activeStep}>
		  				<div className="step-title"><img src={mc}/><span>Mission Control v2</span></div>
		  					<p>Deposits Open Wednesday April 2nd 7 PM EDT</p>
		  		

		  				<div className="step-title"><img src={mc}/><span>Mission Control v1</span></div>
		  			
		  				<div className="locker">
		  					<div className="locker-text">
		  						<h2>Unstake your $xHUBBLE</h2>
		  						<p>Unstake your $xHUBBLE from Mission Control to stop earning rewards and reset your votes.</p>
		  					</div>
		  					<div className="locker-locker">
		  						<div className="locker-icon">
		  							<div className="hubble-icon">
		  								<img src={xi} />
		  							</div>
		  							<div className="icon-text">
		  								<div className="small">Unstake</div>
		  								<div className="large">xHUBBLE</div>
		  							</div>
		  						</div>
		  						<div className="locker-input">
		  							<input ref={unstakeRef} placeholder="0"/>
		  							<button className="max-button" onClick={
								  								setRefToThis(
								  									web3.utils.fromWei(mcBalance,"ether"),
								  									unstakeRef)}>MAX</button>
		  							<span>Balance: {web3.utils.fromWei(mcBalance,"ether")}</span>
		  						</div>
		  						<button onClick={unstake}>Unstake</button>
		  					</div>
		  				</div>


		  			</div>
		  	
		  			
		  			<div className={"step step-4 step--"+activeStep}>
		  				<div className="step-title"><img src={ex}/><span>Galactic Exchange: Special Market</span></div>
		  				<div className="data-tile">
		  					<h3>Mints</h3>
		  					<p className="data-focus">{Math.round(100*web3.utils.fromWei(exMints,"ether"))/100} $EX</p>
		  					<p className="data-item">/{EX_LIMIT} $EX</p>
		  				</div>
		  			
		  				<div className="data-tile">
		  					<h3>Your Remaining Mints</h3>
		  					<p className="data-focus">{Math.round(100*web3.utils.fromWei(remainingMints,"ether")/100)} $EX</p>
		  				</div>
		  			
		  				<div className="locker">
		  					<div className="locker-text">
		  						<h2>Mint $EX 1-to-1</h2>
		  						<p>Mint 1 liquid $EX for 1 $stS. Users can mint 10,000 $EX for each $xHUBBLE they hold.</p>
		  					</div>
		  					<div className="locker-locker">
		  						<div className="locker-icon">
		  							<div className="hubble-icon">
		  								<img src={ex} />
		  							</div>
		  							<div className="icon-text">
		  								<div className="small">Mint</div>
		  								<div className="large">EX</div>
		  							</div>
		  						</div>
		  						<div className="locker-input">
		  							<input ref={exMintRef} placeholder="0"/>
		  							<button className="max-button" onClick={
								  								setRefToThis(
								  									web3.utils.fromWei(stsBalance,"ether"),
								  									exMintRef)}>MAX</button>
		  			
		  						</div>
		  						<button onClick={mintPopup}>Mint</button>
		  					</div>
		  				</div>
		  	
		  
		  	



		  	

		  				
		  			</div>

		  			<div className={"step step-5 step--"+activeStep}>
		  				<div className="step-title"><img src={planet}/><span>Starport: Genesis</span></div>
		  				<div className="claim-all"><button onClick={claimAll}>Claim All</button></div>
			  			<div className="pools">
			  				{
			  					pools.map((pool,index)=>(
			  						<>
			  						<div className="pool">
			  							<div className="pool__image">
			  								<img src={poolImage(pool.address)} />
			  							</div>
			  							<div className="pool__name">{pool.symbol}</div>
			  							<div className="pool__info">

			  								
			  								<p>Your Deposit: ${eval(`Math.round(priceOf(pool.address)*web3.utils.fromWei(userInfo_${index},"ether"))`)}</p>
			  							</div>
			  							<div>
			  								<button onClick={managePool(index)}>
			  									Manage
			  								</button>
			  							</div>
			  						</div>
			  						<div className={`modal modal--pool modal--pool-${index} active-pool--${activePool}`}>
			  							<div className="close-button" onClick={closePoolModal}><img src={closeImg} /></div>
			  							<div className="pm">
			  								<div className="step-title"><img src={poolImage(pool.address)}/><span>{pool.symbol}</span></div>
			  								
			  								<div className="pm__userInfo">
			  									
			  							
			  					

								  				<div className="locker">
								  					<div className="locker-text">
								  						<h2>Withdraw ${pool.symbol}</h2>
								  						<p>Withdraw your ${pool.symbol}</p>
								  					</div>
								  					<div className="locker-locker">
								  						<div className="locker-icon">
								  							<div className="hubble-icon">
								  								<img src={poolImage(pool.address)} />
								  							</div>
								  							<div className="icon-text">
								  								<div className="small">Unstake</div>
								  								<div className="large">{pool.symbol}</div>
								  							</div>
								  						</div>
								  						<div className="locker-input">
								  							<input ref={eval(`unstakeRef_${index}`)} placeholder="0"/>
								  							<button className="max-button" onClick={
								  								setRefToThis(
								  									eval(`web3.utils.fromWei(userInfo_${index},"ether")`),
								  									eval(`unstakeRef_${index}`))}>MAX</button>
								  							<span>Balance: {eval(`web3.utils.fromWei(userInfo_${index},"ether")`)}</span>
								  						</div>
								  						<button onClick={unstakeGenesis(index)}>Withdraw</button>
								  					</div>
								  				</div> 
								  				<div className="locker">
								  					<div className="locker-text">
								  						<h2>Claim Rewards</h2>
								  						<p>Claim your $HUBBLE Rewards.</p>
								  					</div>
								  					<div className="locker-locker">
								  						<div className="locker-icon">
								  							<div className="hubble-icon">
								  								<img src={dd} />
								  							</div>
								  							<div className="icon-text">
								  								<div className="small">Claim</div>
								  								<div className="large">HUBBLE</div>
								  							</div>
								  						</div>
								  						<div className="locker-input locker-input--text">
								  							    {
								  								(index > 1) ? 
								  									(<div>
								  										<div>{eval(`pool_pendingRewards_${index}`)} $HUBBLE</div><div>{eval(`490*Number(pool_pendingRewards_${index})`)/1200} $xHUBBLE</div></div>) :
								  									(<div>{eval(`pool_pendingRewards_${index}`)} $HUBBLE</div>)
								  								}
								  						</div>
								  						<button onClick={claimRewards(index)}>Claim</button>
								  					</div>
								  				</div>
		  			
								  			
			  								</div>
			  							</div>
			  						</div>
			  						</>
			  					))
			  				}
			  			</div>

			  		
		  			</div>


		  			
		  	
		  			
		  		</div>
	       	</div>
	       	<div onClick={toggleMobileNav} className={"nav nav--"+navMobileToggle}>
	       	
	       
				
	       		
	       	
	       		
	       		<div className="link" onClick={()=>{
	       			setActiveStep(2)
	       		}}>Galactic Bank</div>
	       		<div className="link" onClick={()=>{
	       			setActiveStep(3)
	       		}}>Mission Control</div>
	       		<div className="link" onClick={()=>{
	       			setActiveStep(4)
	       		}}>Galactic Exchange</div>
	       	
	       		<div className="link" onClick={()=>{
	       			setActiveStep(5)
	       		}}>Starport</div>
	      
	      
	       	</div>
	       	<div className="wallet">
  				<HubbleIcon /> <span title="hubble">{Math.round(web3.utils.fromWei(hubbleBalance,"ether")*1000)/1000}</span> 
  				<span className="divider"> // </span> 
  				<XhubbleIcon /> <span title="xhubble">{Math.round(web3.utils.fromWei(xhubbleBalance,"ether")*1000)/1000}</span>
  			</div>
		  	<div className="wallet wallet--2">
  				<div className="icon icon--sts"><img src={sts}/></div> <span title="sts">{Math.round(web3.utils.fromWei(stsBalance,"ether")*1000)/1000}</span> 
  				<span className="divider"> // </span> 
  				<div className="icon icon--ex"><img src={ex}/></div> <span title="sts">{Math.round(web3.utils.fromWei(exBalance,"ether")*1000)/1000}</span> 
  				<span className="divider"> // </span> 
  				<div className="icon icon--xex"><img src={xex}/></div> <span title="sts">{Math.round(web3.utils.fromWei(xexBalance,"ether")*1000)/1000}</span> 
  			</div>

	        <div className="dd"><img src={dd} /></div>	  		
	        <div className="connect-button">
	  			<div className="inliner"><ConnectButton /></div>
	  		</div>
	  		
	     <div className={"pending pending--" + isMinting}>
	  			<p className="pending-title">Minting $EX</p>
	  			<p className="pending-text">You will mint {mintingAmount} $EX for {mintingAmount} $stS.</p>
	  			<button onClick={mint121}>MINT</button>
	  			<button onClick={closeMint}>BACK</button>

	  		</div>
	        <div className={"pending pending--" + pending}>
	  			<p className="pending-title">Transaction Pending</p>
	  			<p className="pending-text">{pendingText}</p>
	  			<div className="pending-animation">
	  				<div className="animation"><img src={pend}/></div>
	  			</div>
	  		</div>
      	</div>
  	</div>
  	)
};